import { render, staticRenderFns } from "./ticket-logs.vue?vue&type=template&id=bc071812&scoped=true"
import script from "./ticket-logs.vue?vue&type=script&lang=js"
export * from "./ticket-logs.vue?vue&type=script&lang=js"
import style0 from "./ticket-logs.vue?vue&type=style&index=0&id=bc071812&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc071812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc071812')) {
      api.createRecord('bc071812', component.options)
    } else {
      api.reload('bc071812', component.options)
    }
    module.hot.accept("./ticket-logs.vue?vue&type=template&id=bc071812&scoped=true", function () {
      api.rerender('bc071812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jackpot/ticket-logs.vue"
export default component.exports